(function () {
  function init(root) {
    const track = root.querySelector('[data-drv-lev-track]');
    const cards = [...root.querySelectorAll('[data-drv-lev-card]')];
    const dots = [...root.querySelectorAll('.drv-lev__dot')];
    const slider = root.querySelector('.drv-lev__slider');
    if (!track || cards.length < 2) {
      if (slider) slider.classList.add('is-idle');
      return;
    }
    const step = () => cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
    const index = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (max - track.scrollLeft < 2) return cards.length - 1;
      return Math.min(cards.length - 1, Math.max(0, Math.round(track.scrollLeft / step())));
    };
    const update = () => {
      const i = index();
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      if (slider) slider.classList.toggle('is-idle', track.scrollWidth - track.clientWidth < 2);
    };
    root.querySelector('[data-drv-lev-prev]')?.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
      setTimeout(update, 350);
    });
    root.querySelector('[data-drv-lev-next]')?.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
      setTimeout(update, 350);
    });
    dots.forEach((dot, i) => dot.addEventListener('click', () => {
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
      setTimeout(update, 350);
    }));

    let down = false, x0 = 0, s0 = 0, moved = false;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('a, button, summary')) return;
      e.preventDefault();
      down = true; moved = false; x0 = e.clientX; s0 = track.scrollLeft;
      track.style.cursor = 'grabbing';
      track.style.scrollSnapType = 'none';
      try { track.setPointerCapture(e.pointerId); } catch (err) { return; }
    });
    track.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - x0;
      if (Math.abs(dx) > 5) moved = true;
      track.scrollLeft = s0 - dx;
    });
    const endDrag = (e) => {
      if (!down) return;
      down = false;
      track.style.cursor = '';
      if (track.hasPointerCapture && track.hasPointerCapture(e.pointerId)) track.releasePointerCapture(e.pointerId);
      const i = index();
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
      const done = () => { track.style.scrollSnapType = ''; update(); };
      if ('onscrollend' in track) track.addEventListener('scrollend', done, { once: true });
      else setTimeout(done, 700);
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', (e) => {
      if (!moved) return;
      moved = false; e.preventDefault(); e.stopPropagation();
    }, true);

    track.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
    update();
  }

  const boot = () => document.querySelectorAll('[data-drv-lev]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
